import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const supplierDiversityApiSchema = v.object({
  codeDesc: v.string(),
  codeId: v.optional(v.string()),
  id: v.number(),
  lookupCodeType: v.string(),
});

export const supplierDiversitySchema = v.object({
  ...supplierDiversityApiSchema.entries,
  ...optionSchema.entries,
});

export const supplierDiversitiesApiSchema = paginatedSchema(supplierDiversityApiSchema);

export type SupplierDiversityApi = v.InferOutput<typeof supplierDiversityApiSchema>;
export type SupplierDiversitiesApi = v.InferOutput<typeof supplierDiversitiesApiSchema>;

export type SupplierDiversityFilters = Filters<SupplierDiversityApi>;

export type SupplierDiversityFiltersUpdateApi = FiltersUpdateApi<SupplierDiversityApi>;

export type SupplierDiversity = Prettify<Option<v.InferOutput<typeof supplierDiversitySchema>>>;

export type SupplierDiversities = Entities<SupplierDiversity>;
